export var toCapitalize = function (word) {
    return word.charAt(0).toUpperCase() + word.slice(1);
};
